module.exports = __webpack_public_path__ + "img/b4.7e3f8fa5.png";